export const VERSION_INFO = {
    version: "V2.0",
    commit: "(560f24fb)",
    buildDate: "09-07-2026"
};